/**********************
 * BLOG (Norsk)
 **********************/
import { Card, CardContent } from "./card";
import { Sparkles, BookOpen } from "lucide-react";
import { Button } from "./button";
import React from "react";
export function Blogs({T}) {
  const posts = [
    {
      title: "Navratri: 9 netter for fornyelse",
      excerpt: "Ritualer, farger og intensjoner – én for hver Navratri‑dag.",
      tag: "Festival",
      img: "https://images.unsplash.com/photo-1601731816741-097824f756d9?q=80&w=1600&auto=format&fit=crop",
    },
    {
      title: "Slik velger du veileder",
      excerpt: "Klarsynt, Tarot eller Astrologi? Finn rett retning for spørsmålet ditt.",
      tag: "Guide",
      img: "https://images.unsplash.com/photo-1526318472351-c75fcf070305?q=80&w=1600&auto=format&fit=crop",
    },
    {
      title: "Diwali‑ritualer for velstand",
      excerpt: "Enkel Lakshmi‑puja og moderne praksiser du kan gjøre hjemme.",
      tag: "Velstand",
      img: "https://images.unsplash.com/photo-1605727216801-e27ce1d0cc28?q=80&w=1600&auto=format&fit=crop",
    },
    {
      title: "Drømmesymboler 101",
      excerpt: "Slanger, vann, fall – hva prøver drømmene å si?",
      tag: "Drømmer",
      img: "https://images.unsplash.com/photo-1519681393784-d120267933ba?q=80&w=1600&auto=format&fit=crop",
    },
    {
      title: "Tarot for nybegynnere",
      excerpt: "En 3‑korts legg: fortid, nåtid, utfall – på 5 minutter.",
      tag: "Tarot",
      img: "https://images.unsplash.com/photo-1620504156306-4f6e1980f360?q=80&w=1600&auto=format&fit=crop",
    },
    {
      title: "Overlev Merkur retrograd",
      excerpt: "Kommunikasjonstips og beskyttelse når Merkur snur.",
      tag: "Astrologi",
      img: "https://images.unsplash.com/photo-1475855581690-80accde3ae2b?q=80&w=1600&auto=format&fit=crop",
    },
  ];

  return (
    <section className="py-12 px-4 max-w-7xl mx-auto">
      <div className="flex items-end justify-between mb-6">
        <h2 className="text-2xl md:text-3xl font-extrabold text-purple-900">{T.blogTitle}</h2>
        <Button className="rounded-full bg-purple-600 hover:bg-purple-700 text-white px-5">{T.viewAll}</Button>
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {posts.map((p, i) => (
          <Card
            key={i}
            className="rounded-2xl overflow-hidden shadow-md hover:shadow-lg transition bg-gradient-to-b from-purple-50 to-white"
          >
            <div className="relative h-56 w-full overflow-hidden">
              <img src={p.img} alt={p.title} className="absolute inset-0 w-full h-full object-cover" />
            </div>
            <CardContent className="p-5">
              <span className="inline-flex items-center gap-1 text-xs font-semibold bg-purple-100 text-purple-800 px-2 py-1 rounded-full">
                <Sparkles className="w-3 h-3" /> {p.tag}
              </span>
              <h3 className="mt-3 text-lg font-bold text-gray-900">{p.title}</h3>
              <p className="mt-1 text-sm text-gray-600">{p.excerpt}</p>
              <div className="mt-4 flex items-center justify-between">
                <Button variant="outline" className="rounded-full border-purple-300 text-purple-700 hover:bg-purple-50">
                  {T.read}
                </Button>
                <div className="text-xs text-gray-500 flex items-center gap-2">
                  <BookOpen className="w-4 h-4" /> 3 {T.minutes}
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      <div className="mt-10 rounded-3xl p-6 bg-gradient-to-r from-fuchsia-100 via-purple-100 to-indigo-100 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-gray-800 font-medium">{T.subscribeLine}</p>
        <div className="flex w-full md:w-auto gap-2">
          <input
            type="email"
            placeholder="din@email.no"
            className="flex-1 rounded-full border border-purple-300 px-4 py-2 focus:ring-purple-500 focus:border-purple-500"
          />
          <Button className="rounded-full bg-purple-600 hover:bg-purple-700 text-white">Abonner</Button>
        </div>
      </div>
    </section>
  );
}